// Web component: nox-video

class NoxVideo extends HTMLElement {

	static mutedState = true;

	static speaker = `M11.553 3.064A.75.75 0 0112 3.75v16.5a.75.75 0 01-1.255.555L5.46 16H2.75A1.75 1.75 0 011 14.25v-4.5C1 8.784 1.784 8 2.75 8h2.71l5.285-4.805a.75.75 0 01.808-.13zM10.5 5.445l-4.245 3.86a.75.75 0 01-.505.195h-3a.25.25 0 00-.25.25v4.5c0 .138.112.25.25.25h3a.75.75 0 01.505.195l4.245 3.86V5.445z`;
	static waves = [
		`M18.718 4.222a.75.75 0 011.06 0c4.296 4.296 4.296 11.26 0 15.556a.75.75 0 01-1.06-1.06 9.5 9.5 0 000-13.436.75.75 0 010-1.06z`,
		`M16.243 7.757a.75.75 0 10-1.061 1.061 4.5 4.5 0 010 6.364.75.75 0 001.06 1.06 6 6 0 000-8.485z`
	];

	constructor() {
		super();

		this.active = false;
		this.dragging = false;
	}

	set active(value) {
		this._active = value;
		this.classList.toggle("nox-video-active", value);
	}

	get active() {
		return this._active;
	}

	connectedCallback() {
		let video = this.querySelector("video");
		if (!video) {
			let mutationObserver = new MutationObserver((mutations, observer) => {
				let video = this.querySelector("video");
				if (video) {
					observer.disconnect();
					this.setupVideo(video);
				}
			});
			mutationObserver.observe(this, { childList: true, subtree: false });
		} else {
			this.setupVideo(video);
		}

		this.addEventListener("nox-carousel-active", () => {
			if (!this.active) {
				if (this.video.paused) {
					if (this.video.muted !== NoxVideo.mutedState) {
						this.video.muted = NoxVideo.mutedState;
						this.muteIcon.classList.toggle("muted", this.video.muted);
					}
					this.video.play();
				}
				this.active = true;
			}
		});

		this.addEventListener("nox-carousel-inactive", () => {
			if (!this.video.paused) {
				this.video.pause();
			}
			this.active = false;
		});

		this.addEventListener("nox-carousel-drag-start", () => {
			this.dragging = true;
		});
		this.addEventListener("nox-carousel-drag-end", () => {
			this.dragging = false;
		});
	}


	disconnectedCallback() {

	}

	setupVideo(video) {
		if (this.video) {
			return;
		}
		this.video = video;

		this.video.addEventListener("click", (ev) => {
			ev.stopPropagation();
			if (this.dragging) {
				return;
			}
			if (this.video.muted) {
				this.video.muted = false;
				this.muteIcon.classList.remove("muted");
				NoxVideo.mutedState = false;
				return;
			}
			if (this.active) {
				if (this.video.paused) {
					this.video.play();
				} else {
					this.video.pause();
				}
			} else {
				let event = new MouseEvent("item-selected", {
					bubbles: true,
					cancelable: true,
					view: window,
					detail: { source: this }
				});
				this.dispatchEvent(event);
			}
		});

		this.video.addEventListener("ended", () => {
			video.currentTime = 0;
			video.play();
			let event = new MouseEvent("playback-ended", {
				bubbles: true,
				cancelable: true,
				view: window,
				detail: { source: this }
			});
			this.dispatchEvent(event);
		});

		this.video.controls = false;
		this.video.loop = false;
		this.video.classList.add("nox-video-element");

		this.muteButton = document.createElement("button");
		this.muteButton.classList.add("nox-video-mute-button");
		this.muteButton.setAttribute("aria-label", "Mute");

		this.muteIcon = document.createElementNS("http://www.w3.org/2000/svg", "svg");
		this.muteIcon.classList.add("muted");
		this.muteIcon.setAttribute("viewBox", "0 0 24 24");
		this.muteIcon.setAttribute("width", "24");
		this.muteIcon.setAttribute("height", "24");

		let mutePath = document.createElementNS("http://www.w3.org/2000/svg", "path");
		mutePath.setAttribute("fill-rule", "evenodd");
		mutePath.setAttribute("d", NoxVideo.speaker);
		this.muteIcon.appendChild(mutePath);

		for (let waveD of NoxVideo.waves) {
			let wavePath = document.createElementNS("http://www.w3.org/2000/svg", "path");
			wavePath.classList.add("nox-wave");
			wavePath.setAttribute("fill-rule", "evenodd");
			wavePath.setAttribute("d", waveD);
			this.muteIcon.appendChild(wavePath);
		}

		this.muteButton.appendChild(this.muteIcon);

		this.muteButton.addEventListener("click", (event) => {
			event.stopPropagation();
			this.video.muted = !this.video.muted;
			this.muteIcon.classList.toggle("muted", this.video.muted);
			NoxVideo.mutedState = this.video.muted;
		});

		this.appendChild(this.muteButton);
	}
}
customElements.define("nox-video", NoxVideo);
